module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c001"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("c. 2500 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Sumerian Abacus")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The abacus is the first known physical instrument built for the purpose of carrying out a computation. The abacus enabled people to calculate numbers and measurements beyond their raw mental capacity, to consider "), _c('i', [_vm._v("quantity")]), _vm._v(" in the context of addition, subtraction, and the related operations of multiplication and division. It was the world’s first tabulation machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sumerians of Mesopotamia are believed to be the original inventors of the abacus, as well as significant contributors to the field of mathematics, the foundation that underpins computing and most modern algorithms. Early abacuses such as the Sumerian device did not look like the modern versions with which people today are most familiar. The Sumerian abacus took the form of a flat surface, such as a stone tablet, that had incised parallel lines with counters, such as pebbles, to track quantity. It was not until later that the bead-form abacus came into existence; many believe this form originated in China. A frame, rods, and beads that slide to different positions comprise the modern Chinese abacus; its use is still taught today in much of Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sumerians had sophisticated cities with robust economies and trade. They needed counting and measuring instruments to transact business and distribute goods, such as grain and livestock. The Sumerians are also credited with being the first to use symbols to represent groups of objects to communicate large numbers. They used an arrangement based on the number 60, called the "), _c('i', [_vm._v("sexagesimal system.")]), _vm._v(" We owe to the Sumerians our 60-second minute and 60-minute hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The word "), _c('i', [_vm._v("abacus")]), _vm._v(" itself is derived from the Greek ἄβαξ ("), _c('i', [_vm._v("abax")]), _vm._v(") for “slab or drawing board,” which itself may have come from an early Semitic word, possibly related to the Hebrew word קבא ("), _c('i', [_vm._v("abaq")]), _vm._v("), which means “dust.” A predecessor to the abacus was a smooth drawing board covered with sand or dust. A stylus—perhaps a finger—was dragged through the dust to create columns that represented quantity.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c003_r1"
    }
  }, [_vm._v("Antikythera Mechanism (c. 150 BCE)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c024_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tabulating the US Census (1890)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("Mathematical table of division and conversions of fractions, c. 200–100 BCE, from Uruk, Mesopotamia.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/17-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44394f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c001_r1.vue
// module id = 75
// module chunks = 0